/* ==========================================================================
   SearcherFli > Client > Airlines
   ========================================================================== */

/* Modules */
const Autocomplete = require('@bluekiri/alexandria-contrib-components/components/autocomplete-rxjs/client/js');

/* eslint-disable */
const AutocompleteActions = require('@bluekiri/alexandria-contrib-components/components/autocomplete-rxjs/client/js/store/actions');
/* eslint-enable */

const { actions } = require('../store/actions');

const configuration = require('../config');

/* Init */
function initAirlines(instance) {
    const panel = instance;

    /* Selector */
    const { selector } = instance;

    /* Reference */
    panel.airlines = Autocomplete(
        `${selector} [data-component='AutocompleteRxjs'][data-type='${configuration().type.airlines}']`
    );

    if (!panel.airlines) return;

    /* Actions */
    panel.actions = {
        ...instance.actions,
        changeAirlines: payload => {
            return instance.store.dispatch(actions.changeAirlines(payload));
        }
    };

    /* Reactions */
    panel.reactions = {
        ...instance.reactions,
        changeAirlines: instance.airlines.store.subscribe((_, action) => {
            if (action.type !== AutocompleteActions.types.CHANGE_VALUE) return;

            /* Dispatch */
            instance.actions.changeAirlines(action.payload);
        }),
        clearAirlines: instance.airlines.store.subscribe((_, action) => {
            if (action.type !== AutocompleteActions.types.CLEAR) return;

            /* Dispatch */
            instance.actions.setSearcher({ airline: null });
        })
    };

    /* Start */
    const { value } = instance.airlines.store.select('autocomplete');

    if (!value) {
        return;
    }

    /* Sync */
    instance.actions.setSearcher({ airline: value });
}

/* Destroy */
function destroyAirlines(instance) {
    if (!instance.airlines) return;

    const panel = instance;

    /* Reference */
    instance.airlines.actions.destroy();
    delete panel.airlines;

    /* Actions */
    delete panel.actions.changeAirlines;

    /* Reactions */
    instance.reactions.changeAirlines.unsubscribe();
    delete panel.reactions.changeAirlines;
}

/* Exports */
module.exports = {
    initAirlines,
    destroyAirlines
};
